import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { FormFieldDeterminantRelationship } from "../../../models/form-field-determinant-relationship";
import { FormFieldDeterminantControllerService } from "../../../services/crossed-tables/formfield-determinant-controller.service";
import { BaseError } from "../base-error";
import { FormControllerService } from "../../../services/form-controller/form-controller.service";
import {DeterminantControllerService} from "../../../services/registration-controller/determinant-controller.service";

@Component({
  selector: "app-formfield-determinants",
  templateUrl: "./formfield-determinants.component.html",
  providers: [FormFieldDeterminantControllerService, FormControllerService],
})
export class FormfieldDeterminantsComponent extends BaseError implements OnInit {
  public formFieldDeterminantRelationship: FormFieldDeterminantRelationship[][] = [];
  public serviceId: string;
  public selectedFormFieldDeterminantRelationship: FormFieldDeterminantRelationship;
  public tableSwitched: boolean = false;
  public formFieldsGroup: any[] = [];
  public determinantEdit: any = null;
  public determinantMapById: { [key: string]: string } = {};

  constructor(private formFieldDeterminantControllerService: FormFieldDeterminantControllerService,
              private determinantService: DeterminantControllerService,
              private route: ActivatedRoute,
              toastr: ToastrService,
              private formControllerService: FormControllerService) {
    super(toastr);
  }

  public ngOnInit() {
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
      this.getServiceDeterminantKeyName();
    });
    this.getFormFieldDeterminantRelationship();
  }

  public getServiceDeterminantKeyName() {
    this.determinantService.getServiceDeterminantIdAndName(this.serviceId).subscribe(
      (data) => Object.assign(this.determinantMapById, data),
    );
  }

  public getFormFieldDeterminantRelationship() {

    this.formFieldDeterminantControllerService.getFormFieldDeterminantRelationsList(this.serviceId).subscribe(
      (data) => {
        this.formFieldDeterminantRelationship = data;
        if (this.formFieldDeterminantRelationship[0].length > 0) {
          this.formFieldDeterminantRelationship.sort((a, b) => {
            const aString = a[0].formLabel + a[0].formFieldLabel;
            const bString = b[0].formLabel + b[0].formFieldLabel;
            if (aString < bString) { return -1; }
            if (aString > bString) { return 1; }
            return 0;
          });
        }
        this.formControllerService.getFilteredFormFields(this.serviceId, null, false, true, true, false, false, true, true).subscribe(
          (fdata) => {
            this.formFieldsGroup = this.replaceRowsAndColumnsWithComponents(fdata);
            this.fieldNumberDeterminant(this.formFieldDeterminantRelationship[0], this.formFieldsGroup);
            this.formFieldDeterminantRelationship[0].sort((a: any, b: any) => {
              if (a.fieldNumber > b.fieldNumber) { return -1; }
              if (a.fieldNumber < b.fieldNumber) { return 1; }
              return 0;
          });
        });
      },
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
    );
  }

  private replaceRowsAndColumnsWithComponents(components: any[]): any[] {
    return components.map(component => {
      if (component.rows && component.type === "table") {
        component.components = this.replaceRowsAndColumnsWithComponents(this.getComponentsForRows(component.rows));
        delete component.rows;
      }

      if (component.columns && component.type === "columns") {
        component.components = this.replaceRowsAndColumnsWithComponents(this.getComponentsForColumns(component.columns));
        delete component.columns;
      }

      if (component.components) {
        component.components = this.replaceRowsAndColumnsWithComponents(component.components);
      }
      return component;
    });
  }

  private getComponentsForRows(rows: any[]) {
    const components = [];
    if (Array.isArray(rows)) {
      rows.forEach(row => {
        if (Array.isArray(row)) {
          row.forEach((r: any) => {
            if (r.components && Array.isArray(r.components)) {
              r.components.forEach((component: any) => {
                components.push(component);
              });
            }
          });
        }
      });
    }

    return components;
  }

  private getComponentsForColumns(columns: any[]) {
    const components = [];
    if (Array.isArray(columns)) {
      columns.forEach(column => {
        components.push(column);
      });
    }
    return components;
  }

  public openLayer(event: any) {
    // prevent for form tags
    if (event.type && event.class) {
      this.determinantEdit = event;
    }
  }

  public closeDeterminantLayer(): void {
    this.determinantEdit = null;
  }

  public changeDeterminants(event: any): void {
    this.determinantEdit.customConditional = JSON.stringify(event);
    this.responseSuccessful("Determinants saved successfully!");
  }

  public fieldNumberDeterminant(determinants: any[], formFields: any[]) {
    determinants.forEach((determinant) => {
      const have: number = 0;
      this.updateNumberOfDeterminants(have, determinant, formFields);
      determinant.fieldNumber = have.toString();
    });
  }

  public updateNumberOfDeterminants(have: number, determinant: any, formFields: any[]): void {
    formFields.forEach((field) => {
        if (field.components && field.components.length) {
          field.components.forEach((component: any) => {
            if (component.determinants) {
              component.determinants.forEach((componentDeterminant: any) => {
                if (componentDeterminant.id === determinant.determinantId) {
                  have++;
                }
              });
            }
            if (component.components) {
              this.updateNumberOfDeterminants(have, determinant, component.components);
            }
          });
        }
      });
  }
}
